import React from 'react';
import { Spin } from 'antd';

import './spin-loader.less';

interface Props {
  children?: any;
  isLoading: boolean;
  onTop?: boolean;
  size?: "large" | "default" | "small" | undefined;
}

const SpinLoader = ({ children, isLoading, onTop = false, size = 'large'}: Props) => {
  if (onTop) {
    // Always render the same wrapper — only the spinner inside toggles.
    // Swapping between "<div>{spinner}{children}</div>" and bare "children"
    // puts children at a different tree depth per branch, so React can't
    // match the subtree across a loading transition and remounts it from
    // scratch, wiping any component state underneath every time isLoading
    // flips (e.g. on every refetch of the page this wraps).
    return (
      <div className={`spin-loader-on-top ${size ?? ''}`}>
        {isLoading && <Spin className="spin-container" size={size} />}
        {children}
      </div>
    );
  } else {
    return (
       isLoading ?
      <div className={`spin-loader ${size ?? ''}`}>
        <Spin size={size} />
      </div> :
       children
    );
  }

};

export default SpinLoader;
